import { Button } from "../../../../../components/Button/Button.tsx";
import { ErrorWrapper } from "../../../../../components/Error/ErrorWrapper.tsx";
import {
  type IntercomArticle,
  openIntercomArticleInMessenger,
} from "../../../../../utils/intercom.ts";
import { PanelSection } from "../PanelSection.tsx";

export const ActionsBar = ({
  isLoading,
  isPrimaryActionDisabled,
  primaryActionButtonContent,
  onPrimaryActionClick,
  isSecondaryActionDisabled,
  secondaryActionButtonContent,
  onSecondaryActionClick,
  errors,
  errorsChildren,
  intercomArticle,
}: {
  isLoading: boolean;
  isPrimaryActionDisabled?: boolean;
  primaryActionButtonContent: string;
  onPrimaryActionClick: () => void;
  isSecondaryActionDisabled?: boolean;
  secondaryActionButtonContent?: string;
  onSecondaryActionClick?: () => void;
  errors?: string[];
  errorsChildren?: React.ReactNode;
  intercomArticle?: IntercomArticle;
}) => (
  <PanelSection>
    <ErrorWrapper
      errors={errors}
      className="w-full"
      errorsChildren={errorsChildren}
    >
      <Button
        className="w-full"
        disabled={isPrimaryActionDisabled ?? isLoading}
        onClick={() => {
          onPrimaryActionClick();
        }}
        loading={isLoading}
        // XXX: for analytics with GTM
        id="generation-button"
      >
        {primaryActionButtonContent}
      </Button>
      {secondaryActionButtonContent && (
        <Button
          variant="secondary"
          className="w-full"
          disabled={isSecondaryActionDisabled ?? isLoading}
          onClick={() => {
            onSecondaryActionClick?.();
          }}
        >
          {secondaryActionButtonContent}
        </Button>
      )}
    </ErrorWrapper>
    {intercomArticle && (
      <Button
        iconName="HelpCircle"
        size="sm"
        variant="tertiary"
        onClick={() => openIntercomArticleInMessenger(intercomArticle)}
      >
        <div className="text-secondary">Show help</div>
      </Button>
    )}
  </PanelSection>
);
